import type { SlotContextKey } from '../types/slotContext';

const SEPARATOR = '||'; // unique — `:` and `_` already used in pageInstanceId / tcInstanceId

export function buildSlotContextKey(parts: SlotContextKey): string {
  return [
    parts.pageInstanceId,
    parts.tcInstanceId,
    parts.slotName,
    parts.outerIterationKey,
    parts.iterationKey,
  ].join(SEPARATOR);
}

export function parseSlotContextKey(key: string): SlotContextKey | null {
  const segments = key.split(SEPARATOR);
  if (segments.length !== 5) return null;
  return {
    pageInstanceId: segments[0],
    tcInstanceId: segments[1],
    slotName: segments[2],
    outerIterationKey: segments[3],
    iterationKey: segments[4],
  };
}
